"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isDisplayTooltip = exports.isAfterSaleEnd = exports.getResaleAvailabilityVisibility = exports.getRawDescription = exports.getButtonBgColor = exports.getAvailability = exports.createDescriptionHtmlTooltip = exports.buildResaleURL = void 0;
exports.isIsoDate = isIsoDate;
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
var _lodash = require("lodash");
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _button = require("@gravity/button");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _jsxFileName = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/utils.js",
  _this = void 0;
function cov_f7nlnunsk() {
  var path = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/utils.js";
  var hash = "a5ee23b9868b644d4b6884f03e8a06bf132f61a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/utils.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 10
        },
        end: {
          line: 9,
          column: 17
        }
      },
      "1": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 34
        }
      },
      "2": {
        start: {
          line: 12,
          column: 33
        },
        end: {
          line: 13,
          column: 78
        }
      },
      "3": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 78
        }
      },
      "4": {
        start: {
          line: 16,
          column: 44
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "5": {
        start: {
          line: 17,
          column: 25
        },
        end: {
          line: 17,
          column: 64
        }
      },
      "6": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 26,
          column: 4
        }
      },
      "7": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "8": {
        start: {
          line: 31,
          column: 25
        },
        end: {
          line: 31,
          column: 64
        }
      },
      "9": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "10": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "11": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 17
        }
      },
      "12": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 25
        }
      },
      "13": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 33
        }
      },
      "14": {
        start: {
          line: 43,
          column: 30
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "15": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "16": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 17
        }
      },
      "17": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 49
        }
      },
      "18": {
        start: {
          line: 50,
          column: 30
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "19": {
        start: {
          line: 51,
          column: 12
        },
        end: {
          line: 51,
          column: 14
        }
      },
      "20": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "21": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 36
        }
      },
      "22": {
        start: {
          line: 57,
          column: 9
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "23": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 60,
          column: 36
        }
      },
      "24": {
        start: {
          line: 61,
          column: 9
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "25": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 64,
          column: 36
        }
      },
      "26": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 13
        }
      },
      "27": {
        start: {
          line: 70,
          column: 47
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "28": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 79,
          column: 3
        }
      },
      "29": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 17
        }
      },
      "30": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 84,
          column: 4
        }
      },
      "31": {
        start: {
          line: 87,
          column: 32
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "32": {
        start: {
          line: 91,
          column: 25
        },
        end: {
          line: 91,
          column: 84
        }
      },
      "33": {
        start: {
          line: 92,
          column: 25
        },
        end: {
          line: 92,
          column: 117
        }
      },
      "34": {
        start: {
          line: 94,
          column: 26
        },
        end: {
          line: 94,
          column: 93
        }
      },
      "35": {
        start: {
          line: 96,
          column: 27
        },
        end: {
          line: 96,
          column: 72
        }
      },
      "36": {
        start: {
          line: 97,
          column: 25
        },
        end: {
          line: 97,
          column: 65
        }
      },
      "37": {
        start: {
          line: 99,
          column: 2
        },
        end: {
          line: 99,
          column: 24
        }
      },
      "38": {
        start: {
          line: 102,
          column: 31
        },
        end: {
          line: 115,
          column: 1
        }
      },
      "39": {
        start: {
          line: 104,
          column: 2
        },
        end: {
          line: 112,
          column: 3
        }
      },
      "40": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 68
        }
      },
      "41": {
        start: {
          line: 106,
          column: 9
        },
        end: {
          line: 112,
          column: 3
        }
      },
      "42": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 65
        }
      },
      "43": {
        start: {
          line: 108,
          column: 9
        },
        end: {
          line: 112,
          column: 3
        }
      },
      "44": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 75
        }
      },
      "45": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 40
        }
      },
      "46": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 33
          },
          end: {
            line: 12,
            column: 34
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 78
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 44
          },
          end: {
            line: 16,
            column: 45
          }
        },
        loc: {
          start: {
            line: 16,
            column: 70
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 32
          },
          end: {
            line: 30,
            column: 33
          }
        },
        loc: {
          start: {
            line: 30,
            column: 58
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 30
      },
      "3": {
        name: "isIsoDate",
        decl: {
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 25
          }
        },
        loc: {
          start: {
            line: 35,
            column: 31
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 30
          },
          end: {
            line: 43,
            column: 31
          }
        },
        loc: {
          start: {
            line: 43,
            column: 46
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 43
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 50,
            column: 30
          },
          end: {
            line: 50,
            column: 31
          }
        },
        loc: {
          start: {
            line: 50,
            column: 76
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 70,
            column: 47
          },
          end: {
            line: 70,
            column: 48
          }
        },
        loc: {
          start: {
            line: 70,
            column: 89
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 70
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 87,
            column: 32
          },
          end: {
            line: 87,
            column: 33
          }
        },
        loc: {
          start: {
            line: 90,
            column: 5
          },
          end: {
            line: 100,
            column: 1
          }
        },
        line: 90
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 102,
            column: 31
          },
          end: {
            line: 102,
            column: 32
          }
        },
        loc: {
          start: {
            line: 102,
            column: 87
          },
          end: {
            line: 115,
            column: 1
          }
        },
        line: 102
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 3
          },
          end: {
            line: 13,
            column: 14
          }
        }, {
          start: {
            line: 13,
            column: 18
          },
          end: {
            line: 13,
            column: 41
          }
        }, {
          start: {
            line: 13,
            column: 47
          },
          end: {
            line: 13,
            column: 54
          }
        }, {
          start: {
            line: 13,
            column: 58
          },
          end: {
            line: 13,
            column: 77
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 25,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 5
          },
          end: {
            line: 19,
            column: 19
          }
        }, {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 23,
            column: 8
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 8
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 23
          }
        }, {
          start: {
            line: 32,
            column: 27
          },
          end: {
            line: 32,
            column: 55
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 44
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: 57,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 61
      },
      "8": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 71
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 76,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 12
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 23
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 43
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 45
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 54
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 83,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 74
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 92
          }
        }],
        line: 82
      },
      "11": {
        loc: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 23
          },
          end: {
            line: 89,
            column: 24
          }
        }],
        line: 89
      },
      "12": {
        loc: {
          start: {
            line: 89,
            column: 26
          },
          end: {
            line: 89,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 42
          },
          end: {
            line: 89,
            column: 43
          }
        }],
        line: 89
      },
      "13": {
        loc: {
          start: {
            line: 94,
            column: 26
          },
          end: {
            line: 94,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 62
          },
          end: {
            line: 94,
            column: 76
          }
        }, {
          start: {
            line: 94,
            column: 79
          },
          end: {
            line: 94,
            column: 93
          }
        }],
        line: 94
      },
      "14": {
        loc: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        }, {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        }],
        line: 104
      },
      "15": {
        loc: {
          start: {
            line: 105,
            column: 19
          },
          end: {
            line: 105,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 19
          },
          end: {
            line: 105,
            column: 43
          }
        }, {
          start: {
            line: 105,
            column: 47
          },
          end: {
            line: 105,
            column: 67
          }
        }],
        line: 105
      },
      "16": {
        loc: {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        }, {
          start: {
            line: 108,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        }],
        line: 106
      },
      "17": {
        loc: {
          start: {
            line: 107,
            column: 19
          },
          end: {
            line: 107,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 19
          },
          end: {
            line: 107,
            column: 40
          }
        }, {
          start: {
            line: 107,
            column: 44
          },
          end: {
            line: 107,
            column: 64
          }
        }],
        line: 107
      },
      "18": {
        loc: {
          start: {
            line: 108,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        }, {
          start: {
            line: 110,
            column: 9
          },
          end: {
            line: 112,
            column: 3
          }
        }],
        line: 108
      },
      "19": {
        loc: {
          start: {
            line: 109,
            column: 19
          },
          end: {
            line: 109,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 19
          },
          end: {
            line: 109,
            column: 50
          }
        }, {
          start: {
            line: 109,
            column: 54
          },
          end: {
            line: 109,
            column: 74
          }
        }],
        line: 109
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0],
      "10": [0, 0],
      "11": [0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a5ee23b9868b644d4b6884f03e8a06bf132f61a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_f7nlnunsk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_f7nlnunsk();
var _ = (cov_f7nlnunsk().s[0]++, {
  get: _lodash.get
});
var _ref = (cov_f7nlnunsk().s[1]++, _stylingConstants.default),
  color = _ref.color;
cov_f7nlnunsk().s[2]++;
var getRawDescription = exports.getRawDescription = function getRawDescription(performance, product) {
  cov_f7nlnunsk().f[0]++;
  cov_f7nlnunsk().s[3]++;
  return (cov_f7nlnunsk().b[0][0]++, performance) && (cov_f7nlnunsk().b[0][1]++, performance.description) || (cov_f7nlnunsk().b[0][2]++, product) && (cov_f7nlnunsk().b[0][3]++, product.description);
};

// STX-100489: Create description tooltip with html format
cov_f7nlnunsk().s[4]++;
var createDescriptionHtmlTooltip = exports.createDescriptionHtmlTooltip = function createDescriptionHtmlTooltip(performance, product) {
  cov_f7nlnunsk().f[1]++;
  var rawDescription = (cov_f7nlnunsk().s[5]++, getRawDescription(performance, product));
  cov_f7nlnunsk().s[6]++;
  return (cov_f7nlnunsk().b[1][0]++, rawDescription) && (cov_f7nlnunsk().b[1][1]++, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '220px'
    },
    dangerouslySetInnerHTML: {
      __html: getRawDescription(performance, product)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  })) || (cov_f7nlnunsk().b[1][2]++, null);
};

// STX-100489: Only display tooltip for description with length >= 120
cov_f7nlnunsk().s[7]++;
var isDisplayTooltip = exports.isDisplayTooltip = function isDisplayTooltip(performance, product) {
  cov_f7nlnunsk().f[2]++;
  var rawDescription = (cov_f7nlnunsk().s[8]++, getRawDescription(performance, product));
  cov_f7nlnunsk().s[9]++;
  return (cov_f7nlnunsk().b[2][0]++, rawDescription) && (cov_f7nlnunsk().b[2][1]++, rawDescription.length >= 120);
};
function isIsoDate(str) {
  cov_f7nlnunsk().f[3]++;
  cov_f7nlnunsk().s[10]++;
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) {
    cov_f7nlnunsk().b[3][0]++;
    cov_f7nlnunsk().s[11]++;
    return false;
  } else {
    cov_f7nlnunsk().b[3][1]++;
  }
  var d = (cov_f7nlnunsk().s[12]++, new Date(str));
  cov_f7nlnunsk().s[13]++;
  return d.toISOString() === str;
}
cov_f7nlnunsk().s[14]++;
var isAfterSaleEnd = exports.isAfterSaleEnd = function isAfterSaleEnd(salesEndDate) {
  cov_f7nlnunsk().f[4]++;
  cov_f7nlnunsk().s[15]++;
  if (!isIsoDate(salesEndDate)) {
    cov_f7nlnunsk().b[4][0]++;
    cov_f7nlnunsk().s[16]++;
    return false;
  } else {
    cov_f7nlnunsk().b[4][1]++;
  }
  cov_f7nlnunsk().s[17]++;
  return new Date().toISOString() > salesEndDate;
};
cov_f7nlnunsk().s[18]++;
var buildResaleURL = exports.buildResaleURL = function buildResaleURL(product, performance, resaleAvailability) {
  cov_f7nlnunsk().f[5]++;
  var url = (cov_f7nlnunsk().s[19]++, '');
  cov_f7nlnunsk().s[20]++;
  if (product.productFamilySubType === 'OPEN_PASS') {
    cov_f7nlnunsk().b[5][0]++;
    cov_f7nlnunsk().s[21]++;
    url = "".concat(resaleAvailability.resalePassUrl, "?productId=").concat(product.id, "&checkResaleAvailability=true");
  } else {
    cov_f7nlnunsk().b[5][1]++;
    cov_f7nlnunsk().s[22]++;
    if (performance) {
      cov_f7nlnunsk().b[6][0]++;
      cov_f7nlnunsk().s[23]++;
      url = "".concat(resaleAvailability.resalePerformanceUrl, "?performanceId=").concat(performance.id, "&checkResaleAvailability=true");
    } else {
      cov_f7nlnunsk().b[6][1]++;
      cov_f7nlnunsk().s[24]++;
      if (product) {
        cov_f7nlnunsk().b[7][0]++;
        cov_f7nlnunsk().s[25]++;
        url = "".concat(resaleAvailability.resaleProductUrl, "?productId=").concat(product.id, "&checkResaleAvailability=true");
      } else {
        cov_f7nlnunsk().b[7][1]++;
      }
    }
  }
  cov_f7nlnunsk().s[26]++;
  return url;
};
cov_f7nlnunsk().s[27]++;
var getResaleAvailabilityVisibility = exports.getResaleAvailabilityVisibility = function getResaleAvailabilityVisibility(soldOut, resaleAvailability, product) {
  cov_f7nlnunsk().f[6]++;
  cov_f7nlnunsk().s[28]++;
  if ((cov_f7nlnunsk().b[9][0]++, !soldOut) || (cov_f7nlnunsk().b[9][1]++, !resaleAvailability) || (cov_f7nlnunsk().b[9][2]++, !resaleAvailability.isDisplayResaleLink) || (cov_f7nlnunsk().b[9][3]++, !resaleAvailability.supportedProductTypes) || (cov_f7nlnunsk().b[9][4]++, !resaleAvailability.supportedProductFamilySubTypes)) {
    cov_f7nlnunsk().b[8][0]++;
    cov_f7nlnunsk().s[29]++;
    return false;
  } else {
    cov_f7nlnunsk().b[8][1]++;
  }
  cov_f7nlnunsk().s[30]++;
  return (cov_f7nlnunsk().b[10][0]++, resaleAvailability.supportedProductTypes.includes(product.productType)) || (cov_f7nlnunsk().b[10][1]++, resaleAvailability.supportedProductFamilySubTypes.includes(product.productFamilySubType));
};
cov_f7nlnunsk().s[31]++;
var getButtonBgColor = exports.getButtonBgColor = function getButtonBgColor(_ref2, _ref3) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  var _ref3$desaturateAmoun = _ref3.desaturateAmount,
    desaturateAmount = _ref3$desaturateAmoun === void 0 ? (cov_f7nlnunsk().b[11][0]++, 0) : _ref3$desaturateAmoun,
    _ref3$lightenAmount = _ref3.lightenAmount,
    lightenAmount = _ref3$lightenAmount === void 0 ? (cov_f7nlnunsk().b[12][0]++, 0) : _ref3$lightenAmount;
  cov_f7nlnunsk().f[7]++;
  var primaryBgColor = (cov_f7nlnunsk().s[32]++, _.get(theme, 'button.backgroundColor', color.boxBackground));
  var variantBgColor = (cov_f7nlnunsk().s[33]++, _.get(_themeMapper.evolutionTheme, ['button', variant, 'bgColor'], _themeMapper.evolutionTheme.button.primary.bgColor));
  var selectedBgColor = (cov_f7nlnunsk().s[34]++, variant === _button.ButtonVariant.primary ? (cov_f7nlnunsk().b[13][0]++, primaryBgColor) : (cov_f7nlnunsk().b[13][1]++, variantBgColor));
  var desaturatedColor = (cov_f7nlnunsk().s[35]++, (0, _polished.desaturate)(desaturateAmount, selectedBgColor));
  var lightenedColor = (cov_f7nlnunsk().s[36]++, (0, _polished.lighten)(lightenAmount, desaturatedColor));
  cov_f7nlnunsk().s[37]++;
  return lightenedColor;
};
cov_f7nlnunsk().s[38]++;
var getAvailability = exports.getAvailability = function getAvailability(product, performance, timeslot, hospitalitySession) {
  cov_f7nlnunsk().f[8]++;
  var availability;
  cov_f7nlnunsk().s[39]++;
  if (performance) {
    cov_f7nlnunsk().b[14][0]++;
    cov_f7nlnunsk().s[40]++;
    availability = (cov_f7nlnunsk().b[15][0]++, performance.availability) || (cov_f7nlnunsk().b[15][1]++, product.availability);
  } else {
    cov_f7nlnunsk().b[14][1]++;
    cov_f7nlnunsk().s[41]++;
    if (timeslot) {
      cov_f7nlnunsk().b[16][0]++;
      cov_f7nlnunsk().s[42]++;
      availability = (cov_f7nlnunsk().b[17][0]++, timeslot.availability) || (cov_f7nlnunsk().b[17][1]++, product.availability);
    } else {
      cov_f7nlnunsk().b[16][1]++;
      cov_f7nlnunsk().s[43]++;
      if (hospitalitySession) {
        cov_f7nlnunsk().b[18][0]++;
        cov_f7nlnunsk().s[44]++;
        availability = (cov_f7nlnunsk().b[19][0]++, hospitalitySession.availability) || (cov_f7nlnunsk().b[19][1]++, product.availability);
      } else {
        cov_f7nlnunsk().b[18][1]++;
        cov_f7nlnunsk().s[45]++;
        availability = product.availability;
      }
    }
  }
  cov_f7nlnunsk().s[46]++;
  return availability;
};